import { lazy } from 'react';

export const PlayerUpdateIncreaseDepositLimitBlockForm = lazy(
  () => import('./PlayerUpdateIncreaseDepositLimitBlockForm'),
);
